module.exports = __webpack_public_path__ + "img/linkedin.b3278bfc.svg";